<template>
  <div :class="selected">
  <div class="d-none d-sm-block">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link to="/">Übersicht</router-link>
        </li>
        <li class="breadcrumb-item"><router-link to="/stammdaten">Stammdaten</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">{{
          selected }}</li>
      </ol>
    </nav>
    </div>

    <b-alert v-if="!loading"  :show="items.length==0" variant="info">keine Einträge</b-alert>
   <b-link v-if='selected' :href="link" class="btn btn-sm btn-primary">neuer
    {{ findText(selected) }} Eintrag</b-link>
    <b-form-group v-if="fields.find(e=> e==='name')"
          label="Suche"
          label-for="filter-input"
          label-cols-sm="1"
          content-cols-sm="12" content-col="6"
          label-align-sm="left"
          label-size="sm"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              debounce="500"
              placeholder="Muster eingeben..."
            ></b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = null">Löschen</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

    <div class="table-responsive">
    <b-table ref="item-table" :busy.sync="loading" striped hover id="item-table" :items="items" :fields="fields">
    <template #table-busy>
        <div class="text-center  my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Lädt...</strong>
        </div>
      </template>

    <template #cell(name)="data">
      <b-link :href="editLink(selected, data.item[fields[0]])">
      {{data.value }}
      </b-link>
    </template>
    <template #cell(id)="data">
      <b-link :href="editLink(selected, data.item[fields[0]])">
      {{data.value}}
      </b-link>
    </template>
    <template #cell(senderId)="data">
     {{senderListe[data.value]}}
    </template>
    <template #cell(created)="data">
     {{data.value+':00.000Z'|formatDate}}
    </template>
    <template #cell(modified)="data">
     {{data.value+':00.000Z'|formatDate}}
    </template>
    <!-- weiss nicht wir zu filtern ist, deswegen erstmal hart -->
    <template #cell(logo)="data">
      <b-img :src="downloadLink(selected,data.item[fields[0]],'logo')" fluid alt="Fluid image"></b-img>
    </template>
    <!-- weiss nicht wir zu filtern ist, deswegen erstmal hart -->
    <template #cell(data)="data">
      <a :href="downloadLink(selected, data.item[fields[0]], 'data')">download</a>
    </template>

    <template #cell(action)="data">
      <b-link :href="`/api/generic/delete/${selected}/${data.item[fields[0]]}`" @click="confirm"><i class="bi bi-trash"></i></b-link>
    </template>
    </b-table>
    </div>
    <b-pagination v-if="rows>perPage" v-model="currentPage" :total-rows="rows"
      :per-page="perPage" aria-controls="item-table"></b-pagination>
    <b-link v-if='selected' :href="link" class="btn btn-sm btn-primary">neuer
    {{ findText(selected) }} Eintrag</b-link>
  </div>
</template>

<script>
import api from '@/api/generic'
import utils from '@/utilities'
export default {
  name: 'Stammdaten',
  computed: {
    currentPage: {
      get: function () {
        return this.page
      },
      set: async function (newValue) {
        this.page = newValue
        this.offset = (this.page - 1) * this.perPage
        this.refresh()
      }
    },
    rows () {
      return this.pagedList.size
    }
  },
  watch: {
    filter: function (value) {
      this.update()
    }
  },
  mounted () {
    this.refresh()
  },
  methods: {
    findText (id) {
      for (let i = 0; i < this.genericOptions.length; i++) {
        if (this.genericOptions[i].key === id) {
          return this.genericOptions[i].value
        }
      }
      return id
    },
    deleteLink (type, id) {
      return '/api/generic/delete/' + type + '/' + encodeURI(id)
    },
    editLink (type, id) {
      return '/#/stammdaten/create/' + type + '/' + encodeURI(id)
    },
    downloadLink (type, id, name) {
      return '/api/generic/binary/' + type + '/' + encodeURI(id) + '/' + encodeURI(name) + '?' + new Date().getTime()
    },
    async confirm (event) {
      event.preventDefault()
      let result = confirm('Eintrag löschen?')
      if (result) {
        result = await api.delete(event.target.parentElement.href)
        if (result && !result['errorMessage']) {
          utils.makeToast(this, 'Eintrag geöscht!', 'success')
        } else {
          utils.makeToast(this, result['errorMessage'], 'danger')
        }
      }
      this.update()
    },
    backlink () {
      return '/stammdaten/' + this.$route.params.type
    },
    async update () {
      this.link = '/#/stammdaten/create/' + this.selected + '/0'
      this.linkText = this.selected + ' anlegen'
      if (this.selected !== undefined) {
        this.loading = true
        this.pagedList = await api.list(this.selected, this.offset, this.perPage, {'name': this.filter})
        this.genericOptions = await api.overview()
        this.loading = false
        this.items = this.pagedList.items
        if (this.pagedList.items.length > 0) {
          if (this.pagedList.fields) {
            this.fields = this.pagedList.fields
          } else {
            this.fields = Object.keys(this.pagedList.items[0])
          }
          this.fields.push('action')
        }
      }
    },
    async refresh () {
      this.update()
    },
    mapSender (senderid) {
      let senderListe = {}
      for (let senderCat in this.$store.state.auth.baseData.sender) {
        for (let i = 0; i < this.$store.state.auth.baseData.sender[senderCat].length; i++) {
          senderListe[this.$store.state.auth.baseData.sender[senderCat][i].id] = this.$store.state.auth.baseData.sender[senderCat][i].name
        }
      }
      return senderListe
    }
  },
  data () {
    return {
      loading: false,
      selected: this.$route.params.type,
      link: '/#/stammdaten/create/' + this.selected + '/0',
      linkText: this.selected + ' anlegen',
      items: [],
      pagedList: {},
      genericOptions: [],
      senderListe: this.mapSender(),
      fields: [],
      offset: 0,
      page: 1,
      filter: null,
      perPage: 50
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/StammdatenList.vue